export interface IStateScore {
  environmental: number | null;
  economics: number | null;
  governance: number | null;
  financially: number | null;
  socially: number | null;
  safety: number | null;
  climateResilience: number | null;
  crT: number | null;
  ponderation: number;
}

export interface State {
  id: number;
  name: string;
  countryId: number;
  stateCode: string;
  latitude: string;
  longitude: string;
  possiblePhenomena: StatePossiblePhenomena[] | [];
  grade?: StateGrade | '';
}

export interface StateWithScore extends State, IStateScore {
}

export type StateScore = Pick<StateWithScore, 'environmental' | 'economics' | 'governance' | 'financially' | 'socially'
  | 'ponderation' | 'safety' | 'climateResilience' | 'crT'>

export const stateGrades = ['A', 'B', 'C', 'D'] as const;
export type StateGrade = typeof stateGrades[number];

export const statePossiblePhenomena = ['Sequía', 'Granizo', 'Huracán', 'Inudación', 'Deslave', 'Sismo', 'Helada',
  'Maremoto', 'Chubasco', 'Onda de calor'] as const;
export type StatePossiblePhenomena = typeof statePossiblePhenomena[number];

export const statesByCode = {
  'AGU': 'Aguascalientes',
  'BCN': 'Baja California',
  'BCS': 'Baja California Sur',
  'CAM': 'Campeche',
  'CHP': 'Chiapas',
  'CHH': 'Chihuahua',
  'COA': 'Coahuila',
  'COL': 'Colima',
  'DUR': 'Durango',
  'GUA': 'Guanajuato',
  'GRO': 'Guerrero',
  'HID': 'Hidalgo',
  'JAL': 'Jalisco',
  'CMX': 'Mexico City',
  'MIC': 'Michoacán',
  'MOR': 'Morelos',
  'MEX': 'México',
  'NAY': 'Nayarit',
  'NLE': 'Nuevo León',
  'OAX': 'Oaxaca',
  'PUE': 'Puebla',
  'QUE': 'Querétaro',
  'ROO': 'Quintana Roo',
  'SLP': 'San Luis Potosí',
  'SIN': 'Sinaloa',
  'SON': 'Sonora',
  'TAB': 'Tabasco',
  'TAM': 'Tamaulipas',
  'TLA': 'Tlaxcala',
  'VER': 'Veracruz',
  'YUC': 'Yucatán',
  'ZAC': 'Zacatecas',
};

export const statesByCodeKeys = Object.keys(statesByCode);

export enum StateBulkPropsTitles {
  'Environmental',
  'Economics',
  'Governance',
  'Financially',
  'Socially',
  'Safety',
  'Climate Resilience',
  'CR (T)',
  'Possible Phenomena',
}

export enum StateBulkProps {
  ENVIRONMENTAL = 'Environmental',
  ECONOMICS = 'Economics',
  GOVERNANCE = 'Governance',
  FINANCIALLY = 'Financially',
  SOCIALLY = 'Socially',
  SAFETY = 'Safety',
  CLIMATE_RESILIENCE = 'Climate Resilience',
  CR_T = 'CR (T)',
  POSSIBLE_PHENOMENA = 'Possible Phenomena',
}

export const stateScoreByName = {
  [StateBulkProps.ENVIRONMENTAL]: 'environmental',
  [StateBulkProps.ECONOMICS]: 'economics',
  [StateBulkProps.GOVERNANCE]: 'governance',
  [StateBulkProps.FINANCIALLY]: 'financially',
  [StateBulkProps.SOCIALLY]: 'socially',
  [StateBulkProps.SAFETY]: 'safety',
  [StateBulkProps.CLIMATE_RESILIENCE]: 'climateResilience',
  [StateBulkProps.CR_T]: 'crT',
  [StateBulkProps.POSSIBLE_PHENOMENA]: 'possiblePhenomena',
};
